module.exports = __webpack_public_path__ + "img/qywh-banner-pic.52bcdac2.png";